export const ProductService = {
    getProductData() {
        return [
            {
                product_id: '1',
                product_name: 'Buffalo - Striploin',
                product_price: '39.12',
                product_img: 'https://react-shooping-cart.netlify.app/img/1.jpg',
            },
            {
                product_id: '2',
                product_name: 'Bacardi Breezer - Tropical',
                product_price: '257.92',
                product_img: 'https://react-shooping-cart.netlify.app/img/2.jpg',
            },
            {
                product_id: '3',
                product_name: 'Wine - Gato Negro Cabernet',
                product_price: '51.01',
                product_img: 'https://react-shooping-cart.netlify.app/img/3.jpg',
            },
            {
                product_id: '4',
                product_name: 'Cabbage - Nappa',
                product_price: '250.9',
                product_img: 'https://react-shooping-cart.netlify.app/img/4.jpg',
            },
            {
                product_id: '5',
                product_name: 'Glass Clear 8 Oz',
                product_price: '201.1',
                product_img: 'https://react-shooping-cart.netlify.app/img/7.jpg',
            },
            {
                product_id: '6',
                product_name: 'Sour Puss Raspberry',
                product_price: '134.99',
                product_img: 'https://react-shooping-cart.netlify.app/img/8.jpg',
            },
                        {
                product_id: '7',
                product_name: 'Pork - Chop, Frenched',
                product_price: '199.16',
                product_img: 'https://react-shooping-cart.netlify.app/img/9.jpg',
            },
        ]
    }
}